namespace Areas.Dialogs {
    "use strict";

    export class GpsDialog extends Areas.BaseDialog {

        markerExists: boolean = false;
        gpsData: any;

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters:any) {
            super("Gps", closeHandler, parameters,
            () => {
                Areas.disableButton(this.okButtonId);

                const map = $("#map").dxMap("instance");
                map.on({ "click": addMarker(this) });
                map.on({ "markerRemoved" : markerRemoved(this) });

                if (parameters)
                {
                    map.addMarker({ location: parameters })
                        .then((e) => 
                            { 
                                this.markerExists = true; 
                                map.option("autoAdjust", false); 
                            });
                }
            });
        }

        protected ok = (e: any) => {
            this.close(DialogResult.Ok, this.gpsData);
        }

    }

    function markerRemoved(dialog: GpsDialog) {
        return (e: any) => {
            dialog.markerExists = false;
        }
    }    

    function addMarker(dialog: GpsDialog) {
        return (e: any) => {
            dialog.gpsData = `${e.location.lat}, ${e.location.lng}`;
            const map = $("#map").dxMap("instance");
    
            if (dialog.markerExists) {
                map.removeMarker(0)
                    .then(() => map.addMarker({ location: e.location })
                        .then((e) => { dialog.markerExists = true; Areas.enableButton(dialog.okButtonId); }));
            } else {
                map.addMarker({ location: e.location })
                    .then((e) => { dialog.markerExists = true; Areas.enableButton(dialog.okButtonId); });
            }
        }
    }
    
}